/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'

const styles = Object.assign(
  {},
  require('./PartnerPlanAdminList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanOverviewPageList extends Component {
  static propTypes = {
    header: PropTypes.string,
    listItems: PropTypes.instanceOf(Array),
    openPartnerPlanOverviewForm: PropTypes.func,
  }
  static defaultProps = {
    header: '',
    listItems: [],
    openPartnerPlanOverviewForm: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      submit: false,
      recordSelected: '',
    }
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.fy, headerStyles)}>Year</th>
        <th className={(styles.columns.formurl, headerStyles)}>Partner plan form link</th>
        <th className={(styles.columns.formurl, headerStyles)}>Partner plan guidance link</th>
        <th className={(styles.columns.formurl, headerStyles)}>Phase</th>
        <th className={(styles.columns.formurl, headerStyles)}>Status</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.listItems.length ? (
      this.props.listItems.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${item.Id}-${i}`}>
          <td className={styles.year}>
            {item.year}
          </td>
          <td>{item.formurl}</td>
          <td>{item.guidanceurl}</td>
          <td>{item.planstage}</td>
          <td>{item.status}</td>
          <td>
            <Button
              onClick={() => {
                this.props.openPartnerPlanOverviewForm(item)
              }}
              type="flat"
            >
              EDIT
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noAccountsAndLoans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default PartnerPlanOverviewPageList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Admin/PartnerPlanOverviewPageList.js